import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"

const PCIfaqDate = "2021-11-30"  /* Update the date here when the csv file is changed.  Sorry it's manual for now. */

const PCIFaqIndexPage = ({ data }) => {
  const { allFaqIndexCsv } = data
  return (
    <Layout>
      <SEO title="Index of PCI Frequently Asked Questions | Control Gap" />
      <div
        className="hero about-hero hero-text-center"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div>
          <h1 style={{ color: "white" }}>PCI FAQs Index</h1>
          <h3>
            All published PCI FAQs,
            <br />
            indexed in one place.
          </h3>
        </div>
        <a href="#category-info">
          <i
            className="control-gap"
            style={{
              position: "absolute",
              margin: "auto",
              left: "0",
              right: "0",
              bottom: "65px",
              color: "lightgrey",
              fontSize: "45px",
              width: "100px",
            }}
          >
            s
          </i>
        </a>
      </div>
      <div
        id="category-info"
        className="category-info"
        style={{
          background: "black",
          position: "relative",
        }}
      >
        <div className="container">
          <h3>
            The best ways to keep up to date are to use the{" "}
            <a
              href="https://www.pcisecuritystandards.org/faqs"
              target="_blank"
              rel="noopener noreferrer"
              className="html-link"
            >
              PCI FAQ
            </a>{" "}
            page “Newly Added” and “Most Recently Updated” queries or to follow
            the FAQ RSS feed.
          </h3>
          <h4 style={{ fontWeight: "normal" }}>
            {/* Changes to automate csv information */}
            <strong>Note:</strong> This page is maintained manually and was last
            updated on <strong>{PCIfaqDate}</strong> <br />
            it indexes <strong>{allFaqIndexCsv.edges.length} </strong>
            FAQs with the last being <strong>{allFaqIndexCsv.edges[0].node.Article}.</strong>
          </h4>
          <a href="#faq-list">
            <i
              className="control-gap"
              style={{
                position: "absolute",
                margin: "auto",
                left: "0",
                right: "0",
                bottom: "65px",
                color: "lightgrey",
                fontSize: "45px",
                width: "100px",
              }}
            >
              s
            </i>
          </a>
        </div>
      </div>
      <div className="content-block" id="faq-list">
        <div className="text-content">
          <div className="container">
            <table>
              <thead>
                <tr>
                  <th>Article</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                {allFaqIndexCsv.edges.map(({ node }) => (
                  <tr key={node.Article}>
                    <td>{node.Article}</td>
                    <td>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={node.URL}
                      >
                        {node.Text}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query AllPCIFaq {
    allFaqIndexCsv(sort: { order: DESC, fields: Article }) {
      edges {
        node {
          Article
          ID
          Text
          URL
        }
      }
    }
  }
`

export default PCIFaqIndexPage
